import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    value: false
}

const loadingSlice = createSlice({
    name: 'loading',
    initialState,
    reducers: {
        loading(state) {
            state.value = true;
        },
        loaded(state) {
            state.value = false;
        }
    }
});

export const loadingActions = loadingSlice.actions;

export default loadingSlice.reducer;